export default __webpack_public_path__ + "static/media/icons8-navigation-100.b70590db.svg";